import { ProgressIndicator, ProgressSpinner } from '@sainsburys-tech/luna-progress'

type LoadingIndicatorProps = {
  props?: any
  isLoading?: boolean
}

function LoadingIndicator(props: Readonly<LoadingIndicatorProps>) {
  const isLoading: boolean = props?.isLoading ?? !!props;

  return (
    <div className="ln-u-text-align-center ln-u-soft" data-test='loading'>
      <ProgressIndicator page loading={isLoading}>
        <ProgressSpinner light />
        Loading...
      </ProgressIndicator>
    </div>
  )
}

export default LoadingIndicator
